<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent
      icono-titulo="fas fa-truck"
      texto-titulo="Listado de repartos"
      :to-create-action="{name:'NuevoReparto'}"
      to-create-text="Nuevo reparto"
    ></TituloComponent>
    <div class="main-card mb-3 card col-12 col-md-8 offset-md-2">
      <div class="card-body">
        <DataList
          url="/reparto"
          :fields="fields"
          :rowClick="ver"
          :toPesos="toPesos"
          :toDate="toDate"
          ref="datatable"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BlockUI from "@/components/loaders/BlockUI.vue";
import TituloComponent from "@/components/layouts/TituloComponent.vue";
import DataList from "@/components/layouts/DataList.vue";

export default {
  name: "ListarRepartos",
  components: {DataList, TituloComponent, BlockUI},

  data() {
    return {
      fields: [
        {
          name: "fecha",
          label: "Fecha",
          type: "title",
          class: "text-primary",
          append: ' - '
        },
        {
          name: "repartidor.nombre",
          label: "",
          type: "title",
          class: "",
        },
        {
          name: "estado",
          label: "Estado",
          type: "field",
          class: "text-capitalize text-secondary"
        },
        {
          name: "comprobantes",
          label: "Comprobantes",
          type: "field",
          class: "text-capitalize text-secondary"
        },
      ],
      toPesos: ['total'],
      toDate: ['fecha'],
      loading: false
    };
  },
  mounted() {
  },
  methods: {
    ver(reparto) {
      this.$router.push({name: 'EditarReparto', params: {id: reparto.id}})
    }
  }
}
</script>

<style scoped>

</style>
